import React from 'react';

const EducationItem = ({ institution, degree, year, location }) => (
  <div className="bg-white bg-opacity-10 rounded-2xl shadow-xl p-8 mb-10 hover:shadow-blue-500/30 transition duration-500">
    <h3 className="text-2xl font-semibold mb-2 text-blue-300 border-b border-blue-500 pb-2">
      {institution}
    </h3>
    <p className="text-blue-100 text-base font-medium mb-1">{degree}</p>
    <div className="flex flex-wrap text-blue-200 text-sm gap-x-6">
      <span>{year}</span>
      <span>{location}</span>
    </div>
  </div>
);

const Education = () => {
  const educationList = [
    {
      institution: "PES University",
      degree: "Bachelor of Technology in Computer Science and Engineering",
      year: "2022-2026",
      location: "Bengaluru, India"
    },
    {
      institution: "Indian Institute of Technology Madras",
      degree: "Diploma in Data Science",
      year: "2023-2024",
      location: "Chennai, India"
    },
    {
      institution: "Christ Junior College",
      degree: "12th – PCMB",
      year: "2020-2022",
      location: "Bengaluru, India"
    }
  ];

  return (
    <section id="education" className="py-20 bg-gradient-to-b from-gray-900 to-gray-900">
      <div className="container mx-auto px-6 max-w-4xl">
        <h2 className="text-4xl font-bold mb-16 text-center text-blue-300">Education</h2>
        {educationList.map((edu, index) => (
          <EducationItem key={index} {...edu} />
        ))}
      </div>
    </section>
  );
};

export default Education;